import { render, staticRenderFns } from "./EditaServiceProfessor.vue?vue&type=template&id=f2833d38"
import script from "./EditaServiceProfessor.vue?vue&type=script&lang=js"
export * from "./EditaServiceProfessor.vue?vue&type=script&lang=js"
import style0 from "./EditaServiceProfessor.vue?vue&type=style&index=0&id=f2833d38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports